import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import "../../../styles/Auth/department.css";
import { toast } from "react-toastify";
import { getData, uploadFile, postData, } from '../../../webService/webservice.js'

const DepartmentPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = localStorage.getItem("role");
    const adminStoreIds = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const initialStoreId = JSON.parse(localStorage.getItem("storeIds") || "[]");
    const params = new URLSearchParams(location.search);
    const departmentId = params.get("departmentId");
    const isAddDepartment = location.pathname === '/departments/add';
    const [previewUrl, setPreviewUrl] = useState(null);
    const [departmentImage, setDepartmentImage] = useState(null);
    const [stores, setStores] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [departments, setDepartments] = useState([]);
    const sessionToken = localStorage.getItem("Token");
    const [limit, setLimit] = useState(15);
    const [errors, setErrors] = useState({});
    const [selectedStoreId, setSelectedStoreId] = useState(
        initialStoreId
    );
    const [formData, setFormData] = useState({
        departmentName: '',
        storeId: initialStoreId,
        departmentImageObject: '',
    });
    const [searchQuery, setSearchQuery] = useState('');
    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = localStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };
        fetchStores();
    }, []);

    useEffect(() => {
        const storedStoreId = localStorage.getItem("storeId");
        if (storedStoreId && stores.length > 0) {
            const matchedStore = stores.find((store) => store._id === storedStoreId);
            if (matchedStore) {
                setFormData((prev) => ({
                    ...prev,
                    storeId: matchedStore._id,
                    storeName: matchedStore.storeName,
                }));
            }
        }
    }, [stores]);

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };

    const handleAddDepartment = async (e) => {
        e.preventDefault();
        const validationErrors = validateFields(formData, departmentImage);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        try {
            const token = localStorage.getItem("Token");
            const userId = localStorage.getItem("userId");
            if (userId) {
                const uploadResult = await uploadFile(`files/upload/${userId}`, departmentImage);

                if (uploadResult?.status === 200) {
                    // Build the full image URL
                    const departmentData = {
                        departmentName: formData.departmentName,
                        storeId: formData.storeId,
                        departmentImageObject: uploadResult?.data
                    };
                    console.log("Sending department data:", departmentData);

                    const response = await postData('departments/', departmentData, token);

                    toast.success(response.message || 'Department added successfully');
                    setFormData({
                        departmentName: '',
                        storeId: '',
                        departmentImageObject: '',
                    });
                    setDepartmentImage(null);
                    setPreviewUrl(null);
                    navigate("/departments");
                    triggerRefresh();
                } else {
                    toast.error(uploadResult?.message || "Image upload failed");
                    setFormData({
                        departmentName: '',
                        storeId: '',
                        departmentImageObject: '',
                    });
                    setDepartmentImage(null);
                    setPreviewUrl(null);
                    navigate("/departments");
                    triggerRefresh();
                }
            }
        } catch (error) {
            console.error('Add Product Error:', error);
            toast.error(error.message || 'Add Product Failed');
        }
    };

    useEffect(() => {
        fetchDepartments(currentPage, limit, searchQuery, selectedStoreId);
    }, [currentPage, limit, refreshKey, searchQuery, selectedStoreId]);

    const fetchDepartments = async (page, limit, searchQuery) => {
        const params = {
            page,
            limit,
            departmentName: searchQuery?.trim() || ""
        }
        const sid = Array.isArray(selectedStoreId)
            ? selectedStoreId[0]
            : selectedStoreId;
        if (sid && sid.length === 24) {
            params.storeId = sid;
        }
        // if (selectedStoreId) params.storeId = selectedStoreId;
        try {
            setLoading(true);
            const response = await getData('departments/departments', params, sessionToken);
            const resultsWrapper = response?.data?.[0];
            const departmentsList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setDepartments(departmentsList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            console.error("Failed to load departments", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = selectedStoreId;
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    // const handlePageChange = (direction) => {
    //     setCurrentPage((prev) =>
    //         direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
    //     );
    // };

    // const handleItemsPerPageChange = (e) => {
    //     const newLimit = Number(e.target.value);
    //     setLimit(newLimit);
    //     setCurrentPage(1);
    // };

    const validateFields = (data, departmentImage) => {
        let newErrors = {};

        if (!departmentImage) newErrors.departmentImage = "Department image is required";
        if (!data.departmentName) newErrors.departmentName = "Department Name is required";
        if (!data.stores) newErrors.stores = "Stores is required";

        return newErrors;
    }
    return (
        <div className="department-layout">
            <div className="department-content">
                <main className="department-main">
                    {isAddDepartment ? (
                        <div className="add-department-form">
                            <h3>Add Department</h3>
                            <form className="department-form">
                                <div className="department-form-row">
                                    <div className="department-form-group">
                                        <label htmlFor="departmentName" className="input-label">
                                            Department Name
                                        </label>
                                        <input
                                            type="text"
                                            placeholder="Enter Department name"
                                            required
                                            className="department-input"
                                            value={formData.departmentName}
                                            onChange={e =>
                                                setFormData(prev => ({ ...prev, departmentName: e.target.value }))
                                            }
                                        />
                                        {errors.departmentName && <p className="field-error">{errors.departmentName}</p>}
                                    </div>
                                    <div className="department-form-group">
                                        <label className="input-label">Branch Name</label>
                                        <select
                                            className="category-input"
                                            value={formData.storeId || ""}
                                            onChange={(e) => {
                                                const storeId = e.target.value;
                                                setSelectedStoreId(storeId);
                                                setFormData(prev => ({ ...prev, storeId }));
                                                setSelectedStoreId(storeId)
                                                window.dispatchEvent(new Event("storeChanged"));
                                            }}
                                        >
                                            <option value="">Select Branch</option>
                                            {stores
                                                .filter(store => {
                                                    if (role === "SuperAdmin") {
                                                        // ✅ Show all stores
                                                        return true;
                                                    } else if (role === "FranchiseAdmin") {
                                                        // ✅ Show only admin’s assigned stores
                                                        return adminStoreIds.includes(store._id);
                                                    } else {
                                                        // ✅ For Manager, Biller, etc. — show only their assigned store(s)
                                                        return initialStoreId?.includes(store._id);
                                                    }
                                                })
                                                .map(store => (
                                                    <option key={store._id} value={store._id}>
                                                        {store.storeName}
                                                    </option>
                                                ))}
                                        </select>
                                        {errors.stores && <p className="field-error">{errors.stores}</p>}
                                    </div>
                                    <div className="department-form-group">
                                        <label className="input-label">Department Image</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            id="DepartmentImage"
                                            required
                                            disabled={!formData.departmentName}
                                            className="department-input"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                setDepartmentImage(file);
                                                setPreviewUrl(URL.createObjectURL(file));
                                            }}
                                        />
                                        {errors.departmentImage && <p className="field-error">{errors.departmentImage}</p>}
                                        {previewUrl && (
                                            <div className="image-preview">
                                                <img src={previewUrl} alt="Preview" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="department-buttons">
                                    <button className="add-department-button" type="submit" onClick={handleAddDepartment}>
                                        add Department
                                    </button>
                                    <button className="cancel-department-button" onClick={() => navigate('/departments')}>
                                        cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className="department-widgets">
                                <div className="department-widgets-header">
                                    <h3>Departments</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="department-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <button className="add-btn-department" onClick={() => navigate('/departments/add')}>+ Add department</button>
                            </div>
                            <div className="header-divider"></div>
                            {departments.length === 0 ? (
                                <p>No Departments found</p>
                            ) : (
                                <div className="department-cards-container">
                                    {departments.map((department) => (
                                        <div className="department-card" key={department._id} onClick={() => navigate(`/${department._id}/users`)}
                                            style={{ cursor: "pointer" }}>
                                            <div className="department-info">
                                                <div className="department-avatar">
                                                    <img
                                                        src={
                                                            department.departmentImageObject?.uri
                                                                ? `${process.env.REACT_APP_API_URL}${department.departmentImageObject.uri}`
                                                                : "/assets/mdi--user.svg"
                                                        }
                                                        alt={`${department.name || "Department"} Avatar`}
                                                    />
                                                </div>
                                            </div>
                                            <div className="department-Heading">
                                                <h3 className="department-name">{department.departmentName || "No Name"}</h3>

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </>

                    )}
                </main>
            </div>
        </div>
    );
};

export default DepartmentPage;